/**
 * Scroll `el` into view inside its nearest scrollable ancestor only, never the page.
 *
 * `Element.scrollIntoView` scrolls every scrollable ancestor, the document included. The app frame is a fixed
 * `h-dvh` shell, so a document scroll slides the whole UI up and leaves a blank band below (Clayton, 2026-10-18).
 */
export function scrollWithin(
  el: Element | null | undefined,
  { block = 'nearest', behavior = 'auto' }: { block?: 'start' | 'nearest' | 'end'; behavior?: ScrollBehavior } = {},
): void {
  if (!el) return
  let box = el.parentElement
  while (box && box !== document.body) {
    const style = getComputedStyle(box)
    if (/(auto|scroll)/.test(style.overflowY) && box.scrollHeight > box.clientHeight) break
    box = box.parentElement
  }
  if (!box || box === document.body) return
  const r = el.getBoundingClientRect()
  const b = box.getBoundingClientRect()
  let delta = 0
  if (block === 'start') delta = r.top - b.top
  else if (block === 'end') delta = r.bottom - b.bottom
  else if (r.top < b.top) delta = r.top - b.top
  else if (r.bottom > b.bottom) delta = Math.min(r.bottom - b.bottom, r.top - b.top)
  if (delta !== 0) box.scrollBy?.({ top: delta, behavior })
}
